var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWedelivercolor1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_1680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11.7501V1.27819C14.25 0.856311 14.5781 0.500061 15 0.500061C20.7984 0.500061 25.5 5.20162 25.5 11.0001C25.5 11.4219 25.1438 11.7501 24.7219 11.7501H14.25ZM1.5 13.2501C1.5 7.56412 5.72344 2.85787 11.2031 2.10787C11.6344 2.04694 12 2.39381 12 2.82975V14.0001L19.3359 21.336C19.65 21.6501 19.6266 22.1657 19.2656 22.4188C17.4281 23.7313 15.1781 24.5001 12.75 24.5001C6.53906 24.5001 1.5 19.4657 1.5 13.2501ZM26.175 14.0001C26.6109 14.0001 26.9531 14.3657 26.8969 14.7969C26.5359 17.4172 25.275 19.7469 23.4328 21.4672C23.1516 21.7297 22.7109 21.711 22.4391 21.4344L15 14.0001H26.175Z",
    fill: "#0066FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_1680"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.500061H27V24.5001H0V0.500061Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWedelivercolor1);
export default __webpack_public_path__ + "static/media/wedelivercolor1.e8f7c01bf3796ecc8b7ef56b21f20d55.svg";
export { ForwardRef as ReactComponent };